import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, GlobalStyles, Grid, InputAdornment, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SecurityIcon from '@mui/icons-material/Security';
import DeleteIcon from '@mui/icons-material/Delete';
import {LoadingIndicator} from "../../components/LoadingIndicator";

const COLOR = {
    RED: "red",
    YELLOW: "yellow",
    GREEN: "#39ff14",
    GREY: "grey",
}

const searchField = [
    "id",
    "subject",
    "user_id"
]

export class UserReport extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            filter: {
                reportPriority: -1,
                reportId: null,
                reportType: -1,
                reportStatus: -1,
                userId: null,
                subject: null,
                keyword: "",
                tags: [],
                limit: 10,
                offset: 0,
                sortBy: "latest",
                env: "PROD",
                envText: ``,
                category: -1,
                issueType: -1,
                gameId: 0,
            },
            reports: [],
            total: 0,
            reportTypes: [],
            reportStatuses: [],
            reportPriorities: [],
            categories: [],
            issueTypes: [],
            gameIds: [],
            dialog: {
                loading: false,
                open: false,
                focusOn: null,
                openImage: false,
                imageUrl: null,
            },
            inputValue: "",
            searchField: "id",
            comment: "",
            attachment: "",
            fastReply: [
                "",
                "Thank you for your report",
                "We will investigate this issue",
                "We will fix this issue soon",
            ],
            selectedFastReply: "",
            refs: {
                fileInputRef: React.createRef()
            },
            editCategoryPopup: {
                open: false,
                categories: "",
                issueTypes: "",
            },
            adminId: "NULL",
            adminName: "Admin",
            selectedReportIds: [] as string[],
            bulkReplyDialog: {
                open: false,
                message: "",
                loading: false,
            },
        };
    }

    componentDidMount(): void {
        this.getReports();
    }

    isDevEnv() {
        return this.state.filter.env === "DEV";
    }

    addComment = async () => {
        const {reports, dialog, comment} = this.state;
        const report = reports.find((item: any) => item.id == dialog.focusOn);

        if (!report) {
            PopupMessage.error("Report not found");
            return;
        }

        // Check if attachment is not empty => upload attachment
        const attachment = this.state.attachment;
        let attachmentUrl = '';

        this.onDialogLoading();

        let headers = {
            Authorization: Helpers.getSessionId(),
        }

        if (attachment) {
            let uploadUrl = `${Config.getInstance.apiUrl}/api/user_reports/upload_attachment`;

            const formData = new FormData();
            formData.append("attachment", attachment);
            formData.append("reportId", report.id);

            let uploadResponse;

            if (this.isDevEnv()) {
                uploadResponse = await this.forwardRequest('/linked_api/user_reports/upload_attachment', "post", formData);
            } else {
                uploadResponse = await axios.post(uploadUrl, formData, {
                    headers
                });
            }

            const success = uploadResponse.data.success;

            if (success) {
                attachmentUrl = uploadResponse.data.attachmentUrl;
            } else {
                PopupMessage.error("Attachment upload failed");
                return;
            }
        }

        const comments = report.comments;
        comments.push({
            adminId: this.state.adminId,
            name: "Admin",
            isAdmin: true,
            message: comment,
            createdAt: new Date().toISOString(),
            attachment: attachmentUrl
        });

        let url = `${Config.getInstance.apiUrl}/api/user_reports/add_comment`;

        const data = {
            reportId: report.id,
            comments
        };

        let response;

        if (this.isDevEnv()) {
            response = await this.forwardRequest('/linked_api/user_reports/add_comment', "post", data);
        } else {
            response = await axios.post(url, data, {headers});
        }

        const success = response.data.success;

        if (success) {
            PopupMessage.success("Comment added");
            this.setState({comment: "", attachment: ""});
            this.getReports();
        } else {
            PopupMessage.error("Comment failed");
        }

        this.onDialogLoaded();
    }

    changeFilter(e: any, key: string) {
        const {filter} = this.state;
        filter[key] = e.target.value;
        if (key !== 'offset') {
            // offset should be 0 when limit is changed
            filter.offset = 0;
        }

        if (key === 'category') {
            // reset issue type when category is changed
            filter.issueType = -1;
        }

        this.setState({filter});
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileName = file.name;
            if (fileName.endsWith('.mp4') || fileName.endsWith('.jpeg') || fileName.endsWith('.jpg') || fileName.endsWith('.png')) {
                this.setState({
                    attachment: file
                });
            } else {
                alert('Please select a file with .mp4, .jpeg, .jpg, or .png extension.');
                this.state.refs.fileInputRef.current.value = null;
            }
        }
    }

    removeAttachment = () => {
        this.setState({attachment: ""});
        this.state.refs.fileInputRef.current.value = null;
    }

    onLoading() {
        this.setState({loading: true});
    }

    onDialogLoading() {
        const {dialog} = this.state;
        dialog.loading = true;

        this.setState({dialog});
    }

    onLoaded() {
        this.setState({loading: false});
    }

    onDialogLoaded() {
        const {dialog} = this.state;
        dialog.loading = false;

        this.setState({dialog});
    }

    onChangeFastReply(e: any) {
        const value = e.target.value;
        let {comment} = this.state;

        if (value !== "") {
            // Break line and add fast reply
            let breakLine = "\n";
            if (comment === "") {
                breakLine = "";
            }
            comment = comment + breakLine + value;
        }

        this.setState({selectedFastReply: value, comment});
    }

    async forwardRequest(target: string, method: string, body: any) {
        const url = `${Config.getInstance.apiUrl}/api/forward`;

        const requestBody = {
            endPoint: target,
            method,
            body,
        };

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.post(url, requestBody, {headers});

        return response;
    }

    async getReports() {
        this.onLoading();

        await this.getCategory();

        const {filter} = this.state;
        let params = "";
        // Loop through filter and add to params
        Object.keys(filter).forEach((key: string, index: number) => {
            if (key === "envText") {
                return;
            }

            if (filter[key] != null && filter[key] !== "" && filter[key] != -1) {
                params += `${key}=${filter[key]}&`;
            }
        });

        if (filter.keyword !== "") {
            const field = this.state.searchField;
            params += `field=${field}&`
        }

        // Remove the last & from params
        if (params.length > 0) {
            params = params.substring(0, params.length - 1);
        }

        let url = `${Config.getInstance.apiUrl}/api/user_reports/`;

        let headers = {
            Authorization: Helpers.getSessionId(),
        }

        try {
            let response;

            if (this.isDevEnv()) {
                response = await this.forwardRequest('/linked_api/user_reports', "get", {params});
            } else {
                // Request with params
                response = await axios.get(`${url}?${params}`, {
                    headers,
                    params,
                });
            }


            const success = response.status == 200;
            if (success) {
                const data = response.data;
                console.log('data', data);
                const {reports, total, reportType, reportStatus, reportPriority, adminId, adminName} = data;

                const reportTypes = [...[{name: "ALL", id: -1}], ...reportType];
                const reportStatuses = [...[{name: "ALL", id: -1}], ...reportStatus];
                const reportPriorities = [...[{name: "ALL", id: -1}], ...reportPriority];

                const env = filter.env;

                filter.envText = `Data from ${env} environment`;

                // const {filter} = this.state;

                // if (filter.reportType === null) {
                //     filter.reportType = reportTypes[0].value;
                // }

                // if (filter.reportStatus === null) {
                //     filter.reportStatus = reportStatuses[0].value;
                // }

                // if (filter.reportPriority === null) {
                //     filter.reportPriority = reportPriorities[0].value;
                // }

                // const reportTypes = reportType;
                // const reportStatuses = reportStatus;
                // const reportPriorities = reportPriority;

                const categories = [...[{name: "ALL", id: -1}], ...data.categories];
                const issueTypes = [...[{name: "ALL", id: -1}], ...data.issueTypes];
                const gameIds = [...[{name: "ALL", id: 0}], ...data.gameIds];


                this.setState({
                    filter,
                    reports,
                    total,
                    reportTypes,
                    reportStatuses,
                    reportPriorities,
                    categories,
                    issueTypes,
                    gameIds,
                    adminId,
                    adminName: adminName || "Admin",
                    selectedReportIds: [],
                })

                this.onLoaded();
            }

        } catch (e) {
            console.log('e', e.response);
        }
    }

    async getCategory() {
        const url = `${Config.getInstance.apiUrl}/api/user_reports/get_category`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const response = await axios.get(url, {headers});

        const success = response.status == 200;
        if (success) {
            const data = response.data;
            const categories = data.categories;
            const issueTypes = data.issueTypes;
            const gameIds = data.gameIds;

            const {editCategoryPopup} = this.state;
            editCategoryPopup.categories = categories;
            editCategoryPopup.issueTypes = issueTypes;
            editCategoryPopup.gameIds = gameIds;
            this.setState({editCategoryPopup});
        } else {
            PopupMessage.error("Get category failed");
        }
    }

    clearFilters = () => {
        const {filter} = this.state;
        filter.reportPriority = null;
        filter.reportId = null;
        filter.reportType = null;
        filter.reportStatus = null;
        filter.userId = null;
        filter.subject = null;
        filter.keyword = "";
        filter.tags = [];
        filter.category = null;
        filter.issueType = null;


        this.setState({filter});
    }

    onSearch = () => {
        this.getReports();
    }

    showReportDetail(reportId: string) {
        const {dialog} = this.state;
        dialog.open = true;
        dialog.focusOn = reportId;

        this.setState({dialog, inputValue: ""});
    }

    hideReportDetail() {
        const {dialog} = this.state;
        dialog.open = false;
        dialog.focusOn = null;

        this.setState({dialog});
    }

    showEditCategoryPopup() {
        const {editCategoryPopup} = this.state;
        editCategoryPopup.open = true;

        this.setState({editCategoryPopup});
    }

    hideEditCategoryPopup() {
        const {editCategoryPopup} = this.state;
        editCategoryPopup.open = false;

        this.setState({editCategoryPopup});
    }

    showImage(imageUrl: string) {
        const {dialog} = this.state;
        dialog.openImage = true;
        dialog.imageUrl = imageUrl;

        this.setState({dialog});
    }

    hideImage() {
        const {dialog} = this.state;
        dialog.openImage = false;
        dialog.imageUrl = null;

        this.setState({dialog});
    }

    changePage = (page: number) => {
        const {filter} = this.state;
        const offset = (page - 1) * filter.limit;

        offset >= 0 ? filter.offset = offset : filter.offset = 0;

        this.setState({filter, selectedReportIds: []});

        this.getReports();
    }

    toggleSelectReport = (reportId: string) => {
        this.setState((prev: any) => {
            const set = new Set(prev.selectedReportIds);
            if (set.has(reportId)) {
                set.delete(reportId);
            } else {
                set.add(reportId);
            }
            return {selectedReportIds: [...set]};
        });
    };

    toggleSelectAllOnPage = () => {
        const {reports, selectedReportIds} = this.state;
        if (!reports.length) {
            return;
        }
        const pageIds = reports.map((r: any) => String(r.id));
        const allSelected = pageIds.length > 0 && pageIds.every((id) => selectedReportIds.includes(id));
        this.setState((prev: any) => {
            const set = new Set(prev.selectedReportIds);
            if (allSelected) {
                pageIds.forEach((id) => set.delete(id));
            } else {
                pageIds.forEach((id) => set.add(id));
            }
            return {selectedReportIds: [...set]};
        });
    };

    openBulkReplyDialog = () => {
        if (this.state.selectedReportIds.length === 0) {
            return;
        }
        this.setState({
            bulkReplyDialog: {
                open: true,
                message: "",
                loading: false,
            },
        });
    };

    closeBulkReplyDialog = () => {
        this.setState({
            bulkReplyDialog: {
                open: false,
                message: "",
                loading: false,
            },
        });
    };

    onBulkReplyMessageChange = (e: any) => {
        const value = e.target.value;
        this.setState((prev: any) => ({
            bulkReplyDialog: {...prev.bulkReplyDialog, message: value},
        }));
    };

    getSelectedReportsForBulkDialog = () => {
        const {reports, selectedReportIds} = this.state;
        const set = new Set(selectedReportIds.map(String));
        return reports.filter((r: any) => set.has(String(r.id)));
    };

    submitBulkReply = async () => {
        const {bulkReplyDialog, selectedReportIds} = this.state;
        const message = (bulkReplyDialog.message || "").trim();
        if (!message) {
            PopupMessage.error("Please enter a message");
            return;
        }
        if (selectedReportIds.length === 0) {
            PopupMessage.error("No reports selected");
            return;
        }

        this.setState((prev: any) => ({
            bulkReplyDialog: {...prev.bulkReplyDialog, loading: true},
        }));

        const headers = {
            Authorization: Helpers.getSessionId(),
        };
        const url = `${Config.getInstance.apiUrl}/api/user_reports/bulk_add_comment`;
        const payload = {reportIds: selectedReportIds, message};

        try {
            let response: any;
            if (this.isDevEnv()) {
                response = await this.forwardRequest("/linked_api/user_reports/bulk_add_comment", "post", payload);
            } else {
                response = await axios.post(url, payload, {headers});
            }

            const data = response.data;
            if (data.success) {
                PopupMessage.success(data.message || "Reply sent");
                this.closeBulkReplyDialog();
                this.setState({selectedReportIds: []});
                this.getReports();
            } else {
                PopupMessage.error(data.message || "Bulk reply failed");
            }
        } catch (e: any) {
            const msg = e.response?.data?.message || e.message || "Bulk reply failed";
            PopupMessage.error(msg);
        } finally {
            this.setState((prev: any) => ({
                bulkReplyDialog: {...prev.bulkReplyDialog, loading: false},
            }));
        }
    };

    renderBulkReplyDialog = () => {
        const {bulkReplyDialog, selectedReportIds} = this.state;
        const selectedRows = this.getSelectedReportsForBulkDialog();

        return (
            <Dialog
                open={bulkReplyDialog.open}
                onClose={() => !bulkReplyDialog.loading && this.closeBulkReplyDialog()}
                fullWidth
                maxWidth="sm"
            >
                <DialogContent dividers>
                    <Typography variant="h6" gutterBottom>
                        Reply All ({selectedReportIds.length} reports)
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                        Subjects
                    </Typography>
                    <Box
                        component="ul"
                        sx={{
                            margin: 0,
                            paddingLeft: "1.25rem",
                            maxHeight: 220,
                            overflow: "auto",
                            marginBottom: 2,
                        }}
                    >
                        {selectedRows.map((r: any) => (
                            <Box component="li" key={String(r.id)} sx={{marginBottom: 0.5}}>
                                <Typography variant="body2" component="span">
                                    {r.subject || "(No subject)"}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                    <TextField
                        label="Message"
                        placeholder="Type your reply for all selected reports…"
                        fullWidth
                        multiline
                        minRows={4}
                        value={bulkReplyDialog.message}
                        onChange={this.onBulkReplyMessageChange}
                        disabled={bulkReplyDialog.loading}
                        variant="outlined"
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => this.closeBulkReplyDialog()}
                        color="secondary"
                        variant="contained"
                        disabled={bulkReplyDialog.loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => this.submitBulkReply()}
                        color="primary"
                        variant="contained"
                        disabled={bulkReplyDialog.loading}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    async updateReport() {
        const {reports, dialog, adminId, adminName} = this.state;
        const report = reports.find((item: any) => item.id == dialog.focusOn);

        if (!report) {
            PopupMessage.error("Report not found");
            return;
        }

        try {
            let url = `${Config.getInstance.apiUrl}/api/user_reports/${report.id}`;
            const data = {
                type: report.type,
                priority: report.priority,
                status: report.status,
                tags: report.tags,
                category: report.category,
                issue_type: report.issue_type,
                adminId,
                adminName,
            };
            let headers = {
                Authorization: Helpers.getSessionId(),
            }

            let response;

            if (this.isDevEnv()) {
                response = await this.forwardRequest(`/linked_api/user_reports/${report.id}`, "patch", data);
            } else {
                response = await axios.patch(url, data, {
                    headers,
                });
            }

            const success = response.status == 200;
            if (success) {
                PopupMessage.success("Report updated");
                this.hideReportDetail();

                this.getReports();
            } else {
                PopupMessage.error("Report update failed");
            }
        } catch (e) {
            console.log('e', e.response);
            PopupMessage.error("Report update failed");
        }
    }

    async updateCategory() {
        const url = `${Config.getInstance.apiUrl}/api/user_reports/update_category`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        };
        const {editCategoryPopup} = this.state;
        const body = {
            categories: editCategoryPopup.categories,
            issueTypes: editCategoryPopup.issueTypes,
        };
        
        const response = await axios.post(url, body, {headers});
        const success = response.status == 200;
        if(success) {
            PopupMessage.success("Update category success");
        } else {
            PopupMessage.error("Update category failed");
        }

        this.getReports();
    }

    onCommentChange(e: any) {
        const value = e.target.value;
        this.setState({comment: value});
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    formatDate(dateString) {
        const date = new Date(dateString);

        // Get day, month, year
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        let hours = date.getHours();
        let minutes = date.getMinutes();

        // Convert hours to AM/PM format
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert to 12-hour format

        const hoursStr = String(formattedHours).padStart(2, '0');
        const minutesStr = String(minutes).padStart(2, '0');

        const formattedTimeString = `${hoursStr}:${minutesStr} ${ampm}`;

        return `${day}/${month}/${year} - ${formattedTimeString}`;
    }

    onReportChange(e: any, key: string) {
        const {dialog, reports} = this.state;
        const report = reports.find((item: any) => item.id == dialog.focusOn);

        if (!report) {
            return;
        }

        report[key] = e.target.value;

        if (key === 'category') {
            const currentIssueTypes = this.state.issueTypes.filter((item: any) => item.parentId == e.target.value);

            // reset issue type when category is changed
            if (currentIssueTypes.length > 0) {
                report.issue_type = currentIssueTypes[0].id;
            } else {
                report.issue_type = -1;
            }
        }

        this.setState({reports});
    }

    handleInputChange = (event: any) => {
        const value = event.target.value;
        this.setState({inputValue: value});
    };

    handleAddTag = (event: any, reportId: string, source = "filter") => {
        const key = event.key;
        const {inputValue} = this.state;

        if (key === 'Enter' && inputValue.trim() !== '') {
            const {filter, reports} = this.state;
            let sourceData = filter;

            if (source === "report") {
                const report = reports.find((item: any) => item.id == reportId);
                if (!report) {
                    return;
                }
                sourceData = report;
            }

            sourceData.tags.push(inputValue);
            this.setState({
                inputValue: '',
                filter,
                reports,
            });
        }
    }

    handleDeleteTag = (tag: string, reportId: string, source = "filter") => {
        const {filter, reports} = this.state;
        let sourceData = filter;

        if (source === "report") {
            const report = reports.find((item: any) => item.id == reportId);
            if (!report) {
                return;
            }
            sourceData = report;
        }
        sourceData.tags = sourceData.tags.filter((item: string) => item !== tag);
        this.setState({filter, reports});
    }

    handleChangeSearchField = (e: any) => {
        this.setState({searchField: e.target.value});
    }

    renderReportDetail() {
        const {reports, dialog, reportTypes, reportStatuses, reportPriorities, categories, issueTypes} = this.state;
        const report = reports.find((item: any) => item.id == dialog.focusOn);

        if (!report) {
            return null;
        }

        const gameIds = this.state.gameIds;
        const gameName = gameIds.find((item: any) => item.id == report.game_id)?.name;

        let currentIssueTypes = issueTypes.filter((item: any) => item.parentId == report.category);

        const comments = report.comments;

        const textStyle = {
            display: "flex",
            alignItems: "center",
        }

        const middleContentStyle = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }

        if (typeof report.tags === "string") {
            report.tags = report.tags.length > 0 ? report.tags.split(",") : [];
        }

        const commentRow = {
            borderRadius: "20px",
            border: "1px solid #73AD21",
            minHeight: "100px",
            marginBottom: "10px",
        } as React.CSSProperties;

        const commentContentStyle = {
            padding: "10px",
        } as React.CSSProperties;

        return <Dialog
            open={dialog.open}
            onClose={() => this.hideReportDetail()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            {
                dialog.loading ?
                    <LoadingIndicator classes={""} loadingTextPlaceholder="Uploading..." loadingText={true} />
                    :
                    <div>
                        <DialogContent dividers>

                            <Grid container spacing={2}>
                                <Grid item sm={12}>
                                    <Typography variant="h4" style={{textAlign: "center"}}>
                                        Report Detail
                                    </Typography>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2} style={textStyle}>
                                        <Typography variant="h6">
                                            Report Id:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={9}>
                                        <TextField
                                            fullWidth
                                            value={report.id}
                                        />
                                    </Grid>
                                    <Grid item sm={1} style={middleContentStyle}>
                                        <ContentCopyIcon
                                            onClick={() => this.copyToClipboard(report.id)}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2} style={textStyle}>
                                        <Typography variant="h6">
                                            Game:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={9}>
                                        <TextField
                                            fullWidth
                                            value={gameName}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2} style={textStyle}>
                                        <Typography variant="h6">
                                            User Id:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={9}>
                                        <TextField
                                            fullWidth
                                            value={report.user_id}
                                        />
                                    </Grid>
                                    <Grid item sm={1} style={middleContentStyle}>
                                        <ContentCopyIcon
                                            onClick={() => this.copyToClipboard(report.user_id)}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2} style={textStyle}>
                                        <Typography variant="h6">
                                            Web User Id:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={9}>
                                        <TextField
                                            fullWidth
                                            value={report.web_user}
                                        />
                                    </Grid>
                                    <Grid item sm={1} style={middleContentStyle}>
                                        <ContentCopyIcon
                                            onClick={() => this.copyToClipboard(report.web_user)}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2} style={textStyle}>
                                        <Typography variant="h6">
                                            Subject:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={9}>
                                        <TextField
                                            fullWidth
                                            value={report.subject}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2} style={textStyle}></Grid>
                                    <Grid container item sm={3} spacing={1}>
                                        <Grid item sm={3}>
                                            <Typography variant="h6">
                                                Type:
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Select
                                                value={report.type}
                                                onChange={(e) => this.onReportChange(e, "type")}
                                                size="small"
                                                variant="outlined"
                                                style={{width: "100%"}}
                                            >
                                                {
                                                    reportTypes.map((item: any, index) => {
                                                        if (item.id != -1) {
                                                            return <MenuItem key={index} value={item.id}>{this.renderReportType(item.id)}</MenuItem>
                                                        }
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid container item sm={3} spacing={1}>
                                        <Grid item sm={4}>
                                            <Typography variant="h6">
                                                Priority:
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Select
                                                value={report.priority}
                                                onChange={(e) => this.onReportChange(e, "priority")}
                                                size="small"
                                                variant="outlined"
                                                style={{width: "100%"}}
                                            >
                                                {
                                                    reportPriorities.map((item: any, index) => {
                                                        if (item.id != -1) {
                                                            return <MenuItem key={index} value={item.id}>{this.renderReportPriority(item.id)}</MenuItem>
                                                        }
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid container item sm={4} spacing={1}>
                                        <Grid item sm={3}>
                                            <Typography variant="h6">
                                                Status:
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Select
                                                value={report.status}
                                                onChange={(e) => this.onReportChange(e, "status")}
                                                size="small"
                                                variant="outlined"
                                                style={{width: "100%"}}
                                            >
                                                {
                                                    reportStatuses.map((item: any, index) => {
                                                        if (item.id != -1) {
                                                            return <MenuItem key={index} value={item.id}>{this.renderReportStatus(item.id)}</MenuItem>
                                                        }
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2} style={textStyle}></Grid>
                                    <Grid container item sm={3} spacing={1}>
                                        <Grid item sm={4}>
                                            <Typography variant="h6">
                                                Category:
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Select
                                                value={report.category}
                                                onChange={(e) => this.onReportChange(e, "category")}
                                                size="small"
                                                variant="outlined"
                                                style={{width: "100%"}}
                                            >
                                                {
                                                    categories.map((item: any, index) => {
                                                        if (item.id != -1) {
                                                            return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                        }
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                    <Grid container item sm={3} spacing={1}>
                                        <Grid item sm={4}>
                                            <Typography variant="h6">
                                                IssueType:
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Select
                                                value={report.issue_type}
                                                onChange={(e) => this.onReportChange(e, "issue_type")}
                                                size="small"
                                                variant="outlined"
                                                style={{width: "100%"}}
                                            >
                                                {
                                                    currentIssueTypes.map((item: any, index) => {
                                                        if (item.id != -1) {
                                                            return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                        }
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2}>
                                        <Typography variant="h6">
                                            Tags:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={10}>
                                        {this.renderTags(report.tags, "report", report.id)}
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12}>
                                    <Grid item sm={2}>
                                        <Typography variant="h6">
                                            Description:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={10}>
                                        <TextField
                                            value={report.des}
                                            multiline
                                            rows={6}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12} spacing={1}>
                                    <Grid item sm={2}>
                                        <Typography variant="h6">
                                            Attachment:
                                        </Typography>

                                        <ContentCopyIcon
                                            onClick={() => this.copyToClipboard(report.attachment?.length > 0 ? report.attachment : "Not provided")}
                                        />
                                    </Grid>
                                    <Grid item sm={3}>
                                        {
                                            // Render image from report.attachment
                                            // report.attachment && report.attachment.length > 0 ?
                                            //     <Paper
                                            //         style={{width: "100%"}}
                                            //         onClick={() => this.showImage(report.attachment)}
                                            //     ><img src={report.attachment} style={{width: "100%"}} /></Paper>
                                            //     : <Typography>No screenshot</Typography>

                                            report.attachment && report.attachment.length > 0 ?
                                                <Button
                                                    startIcon={<AttachFileIcon />}
                                                    onClick={() => this.showImage(report.attachment)}
                                                    style={{textTransform: 'none'}}
                                                >
                                                    <Typography>Click to see attachment</Typography>
                                                </Button>
                                                :
                                                <Typography>No screenshot</Typography>
                                        }
                                    </Grid>

                                    <Grid container item sm={7}>
                                        <Grid item container sm={12}>
                                            <Grid item sm={2}>
                                                <Typography variant="h6">
                                                    Device Info:
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={1} style={middleContentStyle}>
                                                <ContentCopyIcon
                                                    onClick={() => this.copyToClipboard(report.information_user?.length > 0 ? report.information_user : "Not provided")}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item sm={12}>
                                            <TextField
                                                value={report.information_user?.length > 0 ? report.information_user : "Not provided"}
                                                fullWidth
                                                multiline
                                                rows={6}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12} spacing={1}>
                                    <Grid item sm={2}>
                                        <Typography variant="h6">
                                            Logs file:
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={7}>
                                        <TextField
                                            fullWidth
                                            value={report.logs ? report.logs : "Not provided"}
                                        />
                                    </Grid>
                                    <Grid item sm={1} style={middleContentStyle}>
                                        <ContentCopyIcon
                                            onClick={() => this.copyToClipboard(report.logs ? report.logs : "Not provided")}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12} spacing={1}>
                                    <Grid item sm={2}>
                                        <Typography variant="h6">
                                            Messages:
                                        </Typography>
                                    </Grid>

                                    <Grid item sm={10}>
                                        {
                                            comments && comments.length > 0 ?
                                                comments.map((comment, index) => (
                                                    <div key={index} style={commentRow}>
                                                        <div style={commentContentStyle}>
                                                            <Typography variant="subtitle1">
                                                                <span style={{
                                                                    fontWeight: "bold",
                                                                    color: comment.isAdmin ? "red" : "#98ABEE"
                                                                }}>{comment.name}</span> {comment.isAdmin ? <SecurityIcon /> : null} - <span style={{
                                                                    color: "grey",
                                                                    fontSize: "12px"
                                                                }}>{this.formatDate(comment.createdAt)}</span>
                                                            </Typography>
                                                            <Typography variant="body1">{comment.message}</Typography>
                                                            {comment.attachment ?
                                                                <Button
                                                                    startIcon={<AttachFileIcon />}
                                                                    onClick={() => this.showImage(comment.attachment)}
                                                                    style={{textTransform: 'none', float: "right"}}
                                                                >
                                                                    <Typography>Click to see attachment</Typography>
                                                                </Button>
                                                                : null}
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <Typography>No messages</Typography>
                                        }
                                    </Grid>
                                </Grid>

                                <Grid container item sm={12} spacing={1}>
                                    <Grid item sm={2}>
                                        <TextField
                                            label="Fast Reply"
                                            select
                                            value={this.state.fastReply[0] || ""}
                                            fullWidth
                                            onChange={(e) => this.onChangeFastReply(e)}
                                        >
                                            {this.state.fastReply.map((item, index) => (
                                                <MenuItem key={index} value={item}
                                                >{item}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item sm={9}>
                                        <TextField
                                            placeholder="Type your message..."
                                            fullWidth
                                            variant="outlined"
                                            value={this.state.comment}
                                            onChange={(e) => this.onCommentChange(e)}
                                            multiline
                                            rows={4}
                                        />
                                        <input
                                            type="file"
                                            style={{display: 'none', float: 'left'}}
                                            ref={this.state.refs.fileInputRef}
                                            onChange={(e) => this.handleFileChange(e)}
                                        />
                                        {!this.state.attachment ? (
                                            <Button
                                                variant='outlined'
                                                startIcon={<AttachFileIcon style={{color: '#1976d2'}} />}
                                                onClick={() => this.state.refs.fileInputRef.current.click()}
                                                style={{marginTop: '10px'}}
                                            >
                                                Choose
                                            </Button>
                                        ) : (
                                            <div style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
                                                <Typography style={{marginRight: '10px'}}>{this.state.attachment.name}</Typography>
                                                <Button
                                                    variant='outlined'
                                                    startIcon={<AttachFileIcon style={{color: '#1976d2'}} />}
                                                    onClick={() => this.state.refs.fileInputRef.current.click()}
                                                    style={{marginRight: '10px'}}
                                                >
                                                    Change
                                                </Button>
                                                <Button
                                                    variant='outlined'
                                                    color='error'
                                                    startIcon={<DeleteIcon />}
                                                    onClick={() => this.removeAttachment()}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        )}
                                    </Grid>

                                    <Grid item sm={1} style={textStyle}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{width: "100%"}}
                                            onClick={() => this.addComment()}
                                        >
                                            Send
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Dialog
                                open={dialog.openImage}
                                onClose={() => this.hideImage()}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                fullWidth={true}
                                maxWidth="lg"
                                style={middleContentStyle}
                            >
                                <DialogContent>
                                    <Typography variant="h6"> {dialog.imageUrl} </Typography>
                                    {
                                        // check if extension is video or image
                                        dialog.imageUrl && dialog.imageUrl.length > 0 ?
                                            dialog.imageUrl.includes("mp4") ?
                                                <video
                                                    src={dialog.imageUrl}
                                                    controls
                                                    style={{width: "100%"}}
                                                />
                                                :
                                                <img
                                                    src={dialog.imageUrl}
                                                    alt="Full Size Image"
                                                    style={{width: "100%"}}
                                                />
                                            : null
                                    }
                                    {/* <img
src={dialog.imageUrl}
alt="Full Size Image"
/> */}
                                </DialogContent>
                            </Dialog>


                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => this.hideReportDetail()}
                                color="secondary"
                                variant="contained"
                                disableElevation
                            >
                                Close
                            </Button>
                            <Button
                                onClick={() => this.updateReport()}
                                color="primary"
                                variant="contained"
                                disableElevation
                            >
                                Save
                            </Button>
                        </DialogActions>
                    </div>
            }

        </Dialog>
    }

    onEditCategory(event, key) {
        const {editCategoryPopup} = this.state;
        editCategoryPopup[key] = event.target.value;

        this.setState({editCategoryPopup});
    }

    renderEditCategoryPopup() {
        const dialog = this.state.editCategoryPopup;

        return <Dialog
            open={dialog.open}
            onClose={() => this.hideEditCategoryPopup()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogContent dividers>
                <Grid container spacing={2} rowSpacing={2}>
                    <Grid item sm={12}>
                        <Typography variant="h4" style={{textAlign: "center"}}>
                            For Dev Only
                        </Typography>
                    </Grid>
                    <Grid container item  sm={6} spacing={2}>
                        <TextField
                            multiline
                            rows={12}
                            fullWidth
                            variant="outlined"
                            label="Categories"
                            value={dialog.categories}
                            onChange={(e) => this.onEditCategory(e, "categories")}
                        >

                        </TextField>
                    </Grid>
                    <Grid container item  sm={6} spacing={2}>
                        <TextField
                            multiline
                            rows={12}
                            fullWidth
                            variant="outlined"
                            label="Issue Types"
                            value={dialog.issueTypes}
                            onChange={(e) => this.onEditCategory(e, "issueTypes")}
                        >

                        </TextField>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => this.hideEditCategoryPopup()}
                    color="secondary"
                    variant="contained"
                    disableElevation
                >
                    Close
                </Button>
                <Button
                    onClick={() => this.updateCategory()}
                    color="primary"
                    variant="contained"
                    disableElevation
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    }

    renderFilters() {
        const {reportTypes, reportStatuses, reportPriorities} = this.state;

        return <Paper elevation={0} className="page-filters" >
            <Grid container spacing={2}>
                <Grid item sm={12}>
                    <Typography variant="h6">
                        Filters
                    </Typography>
                </Grid>
                <Grid item sm={12}>
                    <TextField
                        placeholder="Report Id..."
                        style={{width: "100%"}}
                        value={this.state.filter.reportId}
                        onChange={(e) => this.changeFilter(e, "reportId")}
                        variant="outlined"
                        size="small"
                    />
                </Grid>

                <Grid item sm={12}>
                    <TextField
                        placeholder="UserId..."
                        style={{width: "100%"}}
                        value={this.state.filter.userId}
                        onChange={(e) => this.changeFilter(e, "userId")}
                        variant="outlined"
                        size="small"
                    />
                </Grid>

                <Grid item sm={12}>
                    <TextField
                        placeholder="Subject..."
                        style={{width: "100%"}}
                        value={this.state.filter.subject}
                        onChange={(e) => this.changeFilter(e, "subject")}
                        variant="outlined"
                        size="small"
                    />
                </Grid>

                <Grid item sm={5}>
                    <Typography variant="h6">Type:</Typography>
                </Grid>

                <Grid item sm={7}>
                    <Select
                        placeholder="Report Type..."
                        value={this.state.filter.reportType}
                        onChange={(e) => this.changeFilter(e, "reportType")}
                        size="small"
                        variant="outlined"
                        style={{width: "100%"}}
                    >
                        {
                            reportTypes.map((item: any, index) => {
                                return <MenuItem key={index} value={item.id}>{this.renderReportType(item.id)}</MenuItem>
                            })
                        }

                    </Select>
                </Grid>

                <Grid item sm={5}>
                    <Typography variant="h6">Status:</Typography>
                </Grid>

                <Grid item sm={7}>
                    <Select
                        placeholder="Report Status..."
                        value={this.state.filter.reportStatus}
                        onChange={(e) => this.changeFilter(e, "reportStatus")}
                        size="small"
                        variant="outlined"
                        style={{width: "100%"}}
                    >
                        {
                            reportStatuses.map((item: any, index) => {
                                return <MenuItem key={index} value={item.id}>{this.renderReportStatus(item.id)}</MenuItem>
                            })
                        }

                    </Select>
                </Grid>

                <Grid item sm={5}>
                    <Typography variant="h6">Priority:</Typography>
                </Grid>

                <Grid item sm={7}>
                    <Select
                        placeholder="Report Status..."
                        value={this.state.filter.reportPriority}
                        onChange={(e) => this.changeFilter(e, "reportPriority")}
                        size="small"
                        variant="outlined"
                        style={{width: "100%"}}
                    >
                        {
                            reportPriorities.map((item: any, index) => {
                                const color = "";

                                return <MenuItem key={index} value={item.id}>{this.renderReportPriority(item.id)}</MenuItem>
                            })
                        }

                    </Select>
                </Grid>

                <Grid item xs={6}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        style={{width: "100%"}}
                        onClick={() => this.onSearch()}
                    >
                        Search
                    </Button>
                </Grid>

                <Grid item xs={6}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="secondary"
                        style={{width: "100%"}}
                        onClick={this.clearFilters}
                    >
                        Clear
                    </Button>
                </Grid>
            </Grid>

        </Paper>
    }

    renderTags(tags: string[], source = "filter", reportId = "") {
        const {inputValue} = this.state;

        return (
            <TextField
                fullWidth
                label="Tags"
                variant="outlined"
                value={inputValue}
                onChange={this.handleInputChange}
                onKeyDown={(e) => this.handleAddTag(e, reportId, source)}
                onBlur={() => this.setState({inputValue: ''})}
                InputProps={{
                    startAdornment: tags.map((tag, index) => (
                        <Chip
                            key={index}
                            label={tag}
                            onDelete={() => this.handleDeleteTag(tag, reportId, source)}
                            style={{margin: '2px'}}
                        />
                    )),
                }}
            />
        );
    }

    renderIssueTypes(category) {
        const {issueTypes} = this.state;

        const currentIssueTypes = issueTypes.filter((item: any) => item.parentId == category);

        return <TextField
            select
            label="IssueType"
            value={this.state.issueType}
            onChange={(e) => this.changeFilter(e, "issueType")}
            size="small"
            variant="outlined"
            fullWidth
        >
            {
                currentIssueTypes.map((item: any, index) => {
                    return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                })
            }

        </TextField>
    }

    renderHorizontalFilters() {
        const {reportTypes, reportStatuses, reportPriorities, filter, categories, issueTypes, gameIds} = this.state;

        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            backgroundColor: "black",
        } as React.CSSProperties

        const textStyle = {
            display: "flex",
            alignItems: "center",
        } as React.CSSProperties

        let currentIssueTypes = issueTypes.filter((item: any) => item.parentId == this.state.filter.category);
        if (this.state.filter.category == -1) {
            currentIssueTypes = [{name: "ALL", id: -1}]
        } else {
            currentIssueTypes = [{name: "ALL", id: -1}, ...currentIssueTypes]
        }

        return <Paper style={style}>
            <Grid container sm={12} spacing={2}>
                <Grid item container sm={2} style={textStyle}>
                    <Grid item sm={12}>
                        <TextField
                            select
                            label="Search Field"
                            value={this.state.searchField}
                            onChange={(e) => this.handleChangeSearchField(e)}
                            size="small"
                            variant="outlined"
                            fullWidth
                        >
                            <MenuItem value="id">Report ID</MenuItem>
                            <MenuItem value="subject">Subject</MenuItem>
                            <MenuItem value="user_id">User ID</MenuItem>

                        </TextField>
                    </Grid>
                    <Grid item sm={12}>
                        <TextField
                            placeholder="Search…"
                            onChange={(e) => this.changeFilter(e, "keyword")}
                            value={this.state.filter.keyword}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                        // size="small"
                        >
                        </TextField >
                    </Grid>
                </Grid>

                <Grid item container sm={10} spacing={1}>
                    <Grid item sm={1} style={textStyle}>
                        <Typography variant="h6">
                            Filters:
                        </Typography>
                    </Grid>
                    <Grid item sm={1.5}>
                        <TextField
                            value={this.state.filter.reportType}
                            onChange={(e) => this.changeFilter(e, "reportType")}
                            select
                            label="Type"
                            fullWidth
                        >
                            {
                                reportTypes.map((item: any, index) => {
                                    return <MenuItem key={index} value={item.id}>
                                        {this.renderReportType(item.id)}
                                    </MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                    <Grid item sm={1.5}>
                        <TextField
                            value={this.state.filter.reportPriority}
                            onChange={(e) => this.changeFilter(e, "reportPriority")}
                            select
                            label="Priority"
                            fullWidth
                        >
                            {
                                reportPriorities.map((item: any, index) => {
                                    return <MenuItem key={index} value={item.id}>
                                        {this.renderReportPriority(item.id)}
                                    </MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                    <Grid item sm={1.5}>
                        <TextField
                            value={this.state.filter.reportStatus}
                            onChange={(e) => this.changeFilter(e, "reportStatus")}
                            select
                            label="Status"
                            fullWidth
                        >
                            {
                                reportStatuses.map((item: any, index) => {
                                    return <MenuItem key={index} value={item.id}>
                                        {this.renderReportStatus(item.id)}
                                    </MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                    <Grid item sm={4}>
                        {this.renderTags(filter.tags)}
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            select
                            label="Sort By"
                            value={this.state.filter.sortBy}
                            onChange={(e) => this.changeFilter(e, "sortBy")}
                            variant="outlined"
                            fullWidth
                        >
                            <MenuItem value="latest">Latest</MenuItem>
                            <MenuItem value="highest">Highest</MenuItem>
                            <MenuItem value="newAction">New Action</MenuItem>
                        </TextField>
                    </Grid>
                </Grid>
            </Grid>
            <br></br>
            <Grid container sm={12} spacing={2} justifyContent="flex-end">
                <Grid item container sm={1.5} style={textStyle}>
                    <Grid item sm={12}>
                        <TextField
                            value={this.state.filter.category}
                            onChange={(e) => this.changeFilter(e, "category")}
                            select
                            label="Category"
                            fullWidth
                        >
                            {
                                categories.map((item: any, index) => {
                                    return <MenuItem key={index} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item container sm={1.5} style={textStyle}>
                    <Grid item sm={12}>
                        <TextField
                            value={this.state.filter.issueType}
                            onChange={(e) => this.changeFilter(e, "issueType")}
                            select
                            label="IssueType"
                            fullWidth
                        >
                            {
                                currentIssueTypes.map((item: any, index) => {
                                    return <MenuItem key={index} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="h6">
                        {this.state.filter.envText}
                    </Typography>
                </Grid>
                <Grid item sm={2}>
                    <TextField
                        select
                        label="Env"
                        value={this.state.filter.env}
                        onChange={(e) => this.changeFilter(e, "env")}
                        variant="outlined"
                        size="small">
                        <MenuItem value="PROD">PRODUCTION</MenuItem>
                        <MenuItem value="DEV">DEV</MenuItem>
                    </TextField>
                </Grid>
                <Grid item container sm={1.5} style={textStyle}>
                    <Grid item sm={12}>
                        <TextField
                            value={this.state.filter.gameId}
                            onChange={(e) => this.changeFilter(e, "gameId")}
                            select
                            label="Game"
                            fullWidth
                        >
                            {
                                gameIds.map((item: any, index) => {
                                    return <MenuItem key={index} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item sm={1}>
                    <TextField
                        label="Offset..."
                        value={this.state.filter.offset}
                        onChange={(e) => this.changeFilter(e, "offset")}
                        variant="outlined"
                        size="small"
                    />
                </Grid>
                <Grid item sm={1}>
                    <TextField
                        label="Limit..."
                        value={this.state.filter.limit}
                        onChange={(e) => this.changeFilter(e, "limit")}
                        variant="outlined"
                        size="small"
                    />
                </Grid>
                <Grid item sm={1}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="secondary"
                        style={{width: "100%"}}
                        onClick={this.clearFilters}
                    >
                        Clear
                    </Button>
                </Grid>
                <Grid item sm={1}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        style={{width: "100%"}}
                        onClick={() => this.onSearch()}
                    >
                        Search
                    </Button>
                </Grid>
            </Grid>
            <br></br>
            <Grid container sm={12} spacing={2}>
                <Grid item container sm={3} style={textStyle}>
                    <Button
                        variant="contained"
                        onClick={() => this.showEditCategoryPopup()}
                    >
                        Edit Category / Issue Type
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    }

    renderReportStatus(id: number) {
        const {reportStatuses} = this.state;

        // Get key by id
        const statusObj = reportStatuses.find((item: any) => item.id == id);

        let color = "";

        switch (statusObj.name) {
            case "PENDING":
                color = COLOR.RED;
                break;
            case "RESOLVED":
                color = COLOR.GREEN;
                break;
            case "REJECTED":
                color = COLOR.GREY;
                break;
            case "ACCEPTED":
                color = COLOR.YELLOW;
                break;
            default:
                break;
        }

        return <Typography><span style={{color}}>{statusObj.name}</span></Typography>
    }

    renderReportType(id: number) {
        const {reportTypes} = this.state;

        // console.log("reportTypes: " + JSON.stringify(reportTypes) +"=====" + id);

        // Get key by id
        const typeObj = reportTypes.find((item: any) => item.id == id);
        if (typeObj) {
            let color = "";
            switch (typeObj.name) {
                case "BUG":
                    color = COLOR.RED;
                    break;
                case "FEEDBACK":
                    color = COLOR.YELLOW;
                    break;
                default:
                    break;
            }
            return <Typography><span style={{color}}>{typeObj.name}</span></Typography>
        }
        return <Typography><span > None </span></Typography>
    }

    renderReportPriority(id: number) {
        const {reportPriorities} = this.state;

        // Get key by id
        const priorityObj = reportPriorities.find((item: any) => item.id == id);

        let color = "";

        switch (priorityObj.name) {
            case "LOW":
                color = COLOR.GREEN;
                break;
            case "MEDIUM":
                color = COLOR.YELLOW;
                break;
            case "HIGH":
                color = COLOR.RED;
                break;
            default:
                break;
        }

        return <Typography><span style={{color}}>{priorityObj.name}</span></Typography>
    }

    renderReports() {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={13}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        const {reports, gameIds, selectedReportIds} = this.state;
        const pageIds = reports.map((r: any) => String(r.id));
        const allPageSelected = pageIds.length > 0 && pageIds.every((id) => selectedReportIds.includes(id));
        const somePageSelected = pageIds.some((id) => selectedReportIds.includes(id));

        if (!this.state.loading && reports.length === 0) {
            return <div className="no-items-placeholder">
                <NotInterestedIcon />
                <h3>No reports found</h3>
            </div>;
        }

        const style = {
            padding: '10px',
            width: '100%',
            backgroundColor: "black",
        } as React.CSSProperties

        return <Paper style={style}>
            <Table className="max-table-size">
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox" style={{width: "3%"}}>
                            <Checkbox
                                indeterminate={somePageSelected && !allPageSelected}
                                checked={allPageSelected}
                                onChange={() => this.toggleSelectAllOnPage()}
                                inputProps={{"aria-label": "select all reports on this page"}}
                            />
                        </TableCell>
                        <TableCell style={{width: "5%"}}>#</TableCell>
                        <TableCell style={{width: "5%"}}>Game</TableCell>
                        <TableCell style={{width: "5%"}}>ReportId</TableCell>
                        <TableCell style={{width: "5%"}}>User id</TableCell>
                        <TableCell style={{width: "30%"}} align="center">Subject</TableCell>
                        <TableCell style={{width: "20%"}} align="center">Tags</TableCell>
                        <TableCell style={{width: "5%"}} align="center">Type</TableCell>
                        <TableCell style={{width: "5%"}} align="center">Priority</TableCell>
                        <TableCell style={{width: "5%"}} align="center">Status</TableCell>
                        <TableCell style={{width: "5%"}} align="center">CreatedAt</TableCell>
                        <TableCell style={{width: "5%"}} align="center">UpdatedAt</TableCell>
                        <TableCell style={{width: "5%"}} align="center"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        reports.map((item: any, index: number) => {
                            const gameId = item.game_id;
                            const gameName = gameIds.find((item: any) => item.id == gameId)?.name;
                            const rowId = String(item.id);
                            return <TableRow key={rowId}>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={selectedReportIds.includes(rowId)}
                                        onChange={() => this.toggleSelectReport(rowId)}
                                        inputProps={{"aria-label": `select report ${rowId}`}}
                                    />
                                </TableCell>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{gameName}</TableCell>
                                <TableCell>{item.id}</TableCell>
                                <TableCell>{item.user_id ? item.user_id : item.web_user}</TableCell>
                                <TableCell align="center" style={{overflow: 'hidden', maxWidth: '15px'}}>{item.subject}</TableCell>
                                <TableCell align="center">{item.tags}</TableCell>
                                <TableCell align="center">{this.renderReportType(item.type)}</TableCell>
                                <TableCell align="center">{this.renderReportPriority(item.priority)}</TableCell>
                                <TableCell align="center">{this.renderReportStatus(item.status)}</TableCell>
                                <TableCell align="center">{this.formatDate(item.create_at)}</TableCell>
                                <TableCell align="center">{this.formatDate(item.update_at)}</TableCell>
                                <TableCell align="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<VisibilityIcon />}
                                        onClick={() => this.showReportDetail(item.id)}
                                    >
                                        View
                                    </Button>
                                </TableCell>
                            </TableRow>
                        })
                    }
                    <TableRow>
                        <TableCell colSpan={20} style={{textAlign: 'center', width: "100%"}}>
                            {this.renderPagination()}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    }

    renderPagination() {
        const {total, filter} = this.state;
        const totalPages = Math.ceil(total / filter.limit);

        return <Pagination
            count={totalPages}
            page={filter.offset / filter.limit + 1}
            onChange={(e, page) => this.changePage(page)}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
            style={{marginTop: "20px", display: "ruby"}}
        />
    }

    render() {
        return (
            <div className="contentPadding" style={{width: "100%"}}>
                <GlobalStyles
                    styles={{
                        '*::-webkit-scrollbar': {
                            width: '0.4em',
                        },
                        '*::-webkit-scrollbar-track': {
                            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
                        },
                        '*::-webkit-scrollbar-thumb': {
                            backgroundColor: 'transparent',
                            // outline: '1px solid slategrey',
                        },
                    }}
                />
                {this.renderReportDetail()}
                {this.renderEditCategoryPopup()}
                {this.renderBulkReplyDialog()}
                <Grid container spacing={2}>
                    <Grid item container sm={12}>
                        {this.renderHorizontalFilters()}
                    </Grid>
                    <Grid item container sm={12}>
                        {this.state.selectedReportIds.length > 0 ? (
                            <Paper
                                elevation={0}
                                style={{
                                    padding: "10px 12px",
                                    marginBottom: 10,
                                    width: "100%",
                                    backgroundColor: "#1a1a1a",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                }}
                            >
                                <Typography variant="body2" style={{flex: 1}}>
                                    {this.state.selectedReportIds.length} report
                                    {this.state.selectedReportIds.length === 1 ? "" : "s"} selected
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.openBulkReplyDialog()}
                                >
                                    Reply All
                                </Button>
                            </Paper>
                        ) : null}
                        {this.renderReports()}
                    </Grid>
                </Grid>
            </div>
        )
    }
}